import {Component, Input, OnInit} from '@angular/core';
import {LanguagesService, MessageService} from '../../../../core';
import {GridFormComponent} from '../grid-form.component';
import {ContextMenuSelectEvent} from '@progress/kendo-angular-menu';

@Component({
  selector: 'gc-row-button-pane',
  templateUrl: './row-button-pane.component.html',
  styleUrls: ['./row-button-pane.component.less']
})
export class RowButtonPaneComponent implements OnInit {

  constructor(public lang: LanguagesService, private message: MessageService) {
  }

  // items: any[] = [{
  //   text: 'Item1',
  //   items: [{text: 'Item1.1'}, {text: 'Item1.2'}]
  // }, {
  //   text: 'Item2'
  // }, {
  //   text: 'Item3'
  // }];
  @Input() grid: GridFormComponent;
  @Input() record: { [key: string]: any };

  ngOnInit(): void {

  }

  onMenuSelect(event: ContextMenuSelectEvent): void {
    switch (event.item.data) {
      case 'edit':
        this.grid.startEdit(this.record.serial, {ctrlKey: true});
        break;
      case 'delete':
        this.message.confirm(this.lang.define.lib.deleteConfirmMessage, (r) => {
          if (r) {
            this.grid.delete(this.record.serial);
          }
        });
        break;
      case 'add':
        this.grid.startInsert(null);
        break;
      case 'copy':
        this.grid.startCopy(this.record.serial);
        break;
      case 'view':
        this.grid.viewDetail(this.record.serial);
        break;
      case 'excel':
        this.grid.excel();
        break;

    }
  }
}
